

export const CD_DATA = [
    {
        course_overview: `This German A1 course is designed for absolute beginners who want to build a strong foundation in the German language. You will learn essential vocabulary, basic grammar, and everyday sentence structures used in real-life situations. The course focuses on speaking, listening, reading, and writing skills through guided practice and interactive lessons. By the end of the course, you will be able to introduce yourself, hold simple conversations, and understand basic German confidently.`,
        kt_bullets: [
            "Learn basic German vocabulary and sentence structures for daily communication"
            ,
            "Understand fundamental grammar rules with clear and simple explanations"
            ,
            "Practice speaking and listening through guided exercises and examples"
            ,
            "Build confidence to introduce yourself and talk about common topics"
            ,
            "Prepare a strong base for higher German levels like A2 and B1"
        ],
        contents: [
            {
                query: "Introduction to the German Alphabet & Pronunciation",
                answer: "Learn correct pronunciation, sounds, and letter combinations to develop a strong foundation."
            },

            {
                query: "Basic Grammar & Sentence Structure",
                answer: "Understand nouns, verbs, and essential grammar rules to form simple and correct sentences."
            },

            {
                query: "Everyday Vocabulary Building",
                answer: "Master common words and phrases used in greetings, shopping, travel, and daily conversations."
            },

            {
                query: "Speaking & Listening Practice",
                answer: "Engage in guided conversations and listening exercises to improve fluency and comprehension."
            },

            {
                query: "Reading & Writing Skills",
                answer: "Develop the ability to read short texts, fill out forms, and write simple notes or emails in German."
            },

            {
                query: "Cultural Insights",
                answer: "Gain awareness of German traditions, etiquette, and lifestyle to communicate confidently in real - life situations."
            }
        ]


    },
    {
        course_overview: `The German A2 course is designed for learners who already understand basic German and want to improve their communication skills. This course helps you expand vocabulary, strengthen grammar concepts, and form longer, more meaningful sentences. You will practice speaking and listening through everyday situations while improving reading and writing skills. By the end of the course, you will be able to communicate clearly in common social and professional contexts.`,
        kt_bullets: [
            "Expand German vocabulary for daily conversations and practical situations",
            "Improve grammar usage including tenses, cases, and sentence structure",
            "Develop confidence in speaking with longer and clearer responses",
            "Enhance listening and reading skills using real-life examples",
            "Build readiness for intermediate German levels like B1",
        ],
        contents: [
            {
                query: "Intermediate Grammar & Complex Sentences",
                answer: "Learn to form compound sentences, use modal verbs, and master cases more confidently."
            },

            {
                query: "Expanded Vocabulary for Real-life Situations",
                answer: "Cover topics such as workplace communication, shopping, travel, and making appointments."
            },

            {
                query: "Speaking & Listening Practice at Intermediate Level",
                answer: "Engage in dialogues, role plays, and listening tasks to understand native speed conversations."
            },

            {
                query: "Reading & Writing Skills",
                answer: "Read short articles, stories, and emails while learning to write simple paragraphs and letters."
            },

            {
                query: "Cultural Insights",
                answer: "Understand deeper aspects of German traditions, etiquette, and lifestyle to blend in naturally."
            },
        ]
    },
    {
        course_overview: `The German B1 course is designed for learners who want to communicate independently in German with confidence. This course focuses on improving fluency, accuracy, and comprehension in both spoken and written German. You will learn to express opinions, describe experiences, and handle everyday and professional situations more effectively. By the end of the course, you will be able to participate in conversations and understand standard German used in real-life contexts.`,
        kt_bullets: [
            "Communicate confidently in familiar social and workplace situations",
            "Use grammar structures accurately to form clear and complex sentences",
            "Express opinions, experiences, and plans in spoken and written German",
            "Improve listening and reading comprehension with practical content",
            "Prepare for official German B1 level examinations",

        ],
        contents: [
            {
                query: "Intermediate Grammar & Complex Sentences",
                answer: "Learn to form compound sentences, use modal verbs, and master cases more confidently."
            },
            {
                query: "Expanded Vocabulary for Real-life Situations",
                answer: "Cover topics such as workplace communication, shopping, travel, and making appointments."
            },
            {
                query: "Speaking & Listening Practice at Intermediate Level",
                answer: "Engage in dialogues, role plays, and listening tasks to understand native speed conversations."
            },
            {
                query: "Reading & Writing Skills",
                answer: "Read short articles, stories, and emails while learning to write simple paragraphs and letters."
            },
            {
                query: "Cultural Insights",
                answer: "Understand deeper aspects of German traditions, etiquette, and lifestyle to blend in naturally."
            },

        ]


    },
    {
        course_overview: `The German B2 course is designed for learners who want to use German fluently and effectively in professional and academic environments. This course focuses on refining grammar, expanding vocabulary, and improving clarity in communication. You will learn to understand complex texts, express detailed ideas, and participate confidently in discussions. By the end of the course, you will be able to communicate with ease and accuracy in most real-life situations.`,
        kt_bullets: [
            "Communicate fluently and confidently in professional and social contexts",
            "Understand complex texts and conversations with minimal difficulty",
            "Use advanced grammar structures accurately and effectively",
            "Express detailed opinions, arguments, and explanations clearly",
            "Prepare for internationally recognized German B2 examinations",

        ],
        contents: [
            {
                query: "Intermediate Grammar & Complex Sentences",
                answer: "Learn to form compound sentences, use modal verbs, and master cases more confidently."
            },
            {
                query: "Expanded Vocabulary for Real-life Situations",
                answer: "Cover topics such as workplace communication, shopping, travel, and making appointments."
            },
            {
                query: "Speaking & Listening Practice at Intermediate Level",
                answer: "Engage in dialogues, role plays, and listening tasks to understand native speed conversations."
            },
            {
                query: "Reading & Writing Skills",
                answer: "Read short articles, stories, and emails while learning to write simple paragraphs and letters."
            },
            {
                query: "Cultural Insights",
                answer: "Understand deeper aspects of German traditions, etiquette, and lifestyle to blend in naturally."
            },


        ]

    },
    {
        course_overview: `The German C1 course is designed for advanced learners who want to use German effectively in academic, professional, and formal settings. This course focuses on mastering complex grammar, refining vocabulary, and improving fluency and precision in communication. You will learn to understand demanding texts, express ideas clearly, and participate confidently in detailed discussions. By the end of the course, you will be able to communicate naturally with a high level of accuracy and confidence.`,
        kt_bullets: [
            "Communicate fluently and accurately in academic and professional contexts",
            "Understand complex written and spoken German with ease",
            "Use advanced vocabulary and grammar with precision and clarity",
            "Express detailed arguments and ideas confidently in discussions",
            "Prepare for internationally recognized German C1 examinations",

        ],
        contents: [
            {
                query: "Intermediate Grammar & Complex Sentences",
                answer: "Learn to form compound sentences, use modal verbs, and master cases more confidently."
            },
            {
                query: "Expanded Vocabulary for Real-life Situations",
                answer: "Cover topics such as workplace communication, shopping, travel, and making appointments."
            },
            {
                query: "Speaking & Listening Practice at Intermediate Level",
                answer: "Engage in dialogues, role plays, and listening tasks to understand native speed conversations."
            },
            {
                query: "Reading & Writing Skills",
                answer: "Read short articles, stories, and emails while learning to write simple paragraphs and letters."
            },
            {
                query: "Cultural Insights",
                answer: "Understand deeper aspects of German traditions, etiquette, and lifestyle to blend in naturally."
            },

        ]

    },
    {
        course_overview: `The German C2 course is designed for learners who aim to achieve complete mastery of the German language. This course focuses on refining near-native fluency, precision, and stylistic accuracy in both spoken and written German. You will work with complex texts, advanced expressions, and nuanced language usage across academic and professional contexts. By the end of the course, you will be able to communicate effortlessly, understand subtle meanings, and use German at an expert level.`,
        kt_bullets: [
            "Achieve near-native fluency in spoken and written German",
            "Understand complex, abstract, and specialized texts with ease",
            "Use advanced vocabulary and grammar with complete accuracy",
            "Express subtle meanings, opinions, and arguments confidently",
            "Prepare for internationally recognized German C2 examinations",

        ],
        contents: [
            {
                query: "Intermediate Grammar & Complex Sentences",
                answer: "Learn to form compound sentences, use modal verbs, and master cases more confidently."
            },
            {
                query: "Expanded Vocabulary for Real-life Situations",
                answer: "Cover topics such as workplace communication, shopping, travel, and making appointments."
            },
            {
                query: "Speaking & Listening Practice at Intermediate Level",
                answer: "Engage in dialogues, role plays, and listening tasks to understand native speed conversations."
            },
            {
                query: "Reading & Writing Skills",
                answer: "Read short articles, stories, and emails while learning to write simple paragraphs and letters."
            },
            {
                query: "Cultural Insights",
                answer: "Understand deeper aspects of German traditions, etiquette, and lifestyle to blend in naturally."
            },

        ]

    },

]